import React from 'react';

/**
 * FilterChipGroup — reusable selectable chip bar
 *
 * Props:
 *   options   {Array}  [{ label: string, value: any, icon?: string }]
 *   value     {any}    currently selected value
 *   onChange  {fn}     (value) => void
 *   label     {string} optional group label shown left of chips
 *   name      {string} html name attribute (for a11y)
 */
const FilterChipGroup = ({ options = [], value, onChange, label, name }) => {
  return (
    <div className="adm-chip-group" role="group" aria-label={label || name || 'filter'}>
      <div className="adm-chip-group__chips">
        {options.map((opt) => {
          const isActive = opt.value === value;
          return (
            <button
              key={String(opt.value)}
              type="button"
              className={`adm-chip${isActive ? ' adm-chip--active' : ''}`}
              onClick={() => typeof onChange === 'function' && onChange(opt.value)}
              aria-pressed={isActive}
              title={opt.label}
            >
              {opt.icon && (
                <i className={`${opt.icon} adm-chip__icon`} aria-hidden="true" />
              )}
              <span>{opt.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default FilterChipGroup;
